import styles from "./ScholarshipVideo.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import useTranslationHook from "hooks/useTranslationHook";

const ScholarshipVideo = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslationHook();

  const desktopContent = (
    <div className={styles.scholarshipVideoContainer}>
      <div className={styles.videoContent}>
        <div className={styles.textSection}>
          <h2 className={styles.title}>
            <span className={styles.desktopTitle}>
              {t("scholarship.scholarshipvideo.desktoptitle")}
            </span>
            <span className={styles.mobileTitle}>
              {t("scholarship.scholarshipvideo.mobiletitle")}
            </span>
          </h2>
          <p className={styles.description}>
            <strong>{t("scholarship.scholarshipvideo.description1")}</strong>
          </p>
          <p className={styles.description}>{t("scholarship.scholarshipvideo.description2")}</p>
          <p className={styles.launchInfo}>
            {t("scholarship.scholarshipvideo.launchinfo1.part1")}{" "}
            <strong>{t("scholarship.scholarshipvideo.launchinfo1.bold")}</strong>
          </p>
          <p className={styles.launchInfo}>{t("scholarship.scholarshipvideo.launchinfo2")}</p>
        </div>

        <div className={styles.videoSection}>
          <div className={styles.videoWrapper}>
            <iframe
              className={styles.videoFrame}
              src="https://www.youtube.com/embed/UK-cAqUHllc"
              title={t("scholarship.scholarshipvideo.videotitle")}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );

  if (isDesktop) {
    return desktopContent;
  }

  return desktopContent;
};

export default wrapperHOC(ScholarshipVideo, {
  componentName: "ScholarshipVideo-ScholarshipDesktop",
  showForChina: true,
});
